/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Shared_DaysInputs */

const en_shared_days = /** @type {(inputs: Shared_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} day`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} days`);
	return /** @type {LocalizedString} */ ("shared.days");
};

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const de_shared_days = en_shared_days;

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const es_shared_days = en_shared_days;

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const fr_shared_days = en_shared_days;

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const it_shared_days = en_shared_days;

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const pt_br2_shared_days = en_shared_days;

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const pl_shared_days = en_shared_days;

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const hu_shared_days = en_shared_days;

/** @type {(inputs: Shared_DaysInputs) => LocalizedString} */
const ro_shared_days = en_shared_days;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} day" |
* | "other" | "{count} days" |
*
* @param {Shared_DaysInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_days = /** @type {((inputs: Shared_DaysInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_DaysInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_days(inputs)
	if (locale === "de") return de_shared_days(inputs)
	if (locale === "es") return es_shared_days(inputs)
	if (locale === "fr") return fr_shared_days(inputs)
	if (locale === "it") return it_shared_days(inputs)
	if (locale === "pt-BR") return pt_br2_shared_days(inputs)
	if (locale === "pl") return pl_shared_days(inputs)
	if (locale === "hu") return hu_shared_days(inputs)
	return ro_shared_days(inputs)
});
export { shared_days as "shared.days" }